import api from '@/services/api';

// TODO(new-avenant): la branche feature/new-avenant n'expose pas de routes dédiées
// `PUT /v1/amendments/:id` ni `DELETE /v1/amendments/:id`. Les éditions continuent
// donc à passer par `PUT /v1/subscriptions/:id` et l'annulation par
// `PUT /v1/subscriptions/:id/revert`.

function getPolicyFromId(policyId) {
  return api().get(`policies/${policyId}`);
}

function updatePolicyRisk(policyId, body) {
  return api().patch(`policies/${policyId}/risk`, body);
}

function createAmendmentFromPolicy(policyId) {
  return api().post(`policies/${policyId}/amendments`);
}

function findPolicyAmendments(policyId) {
  return api().get(`policies/${policyId}/amendments`);
}

function findPolicyAmendmentDiff(amendmentId) {
  return api().get(`policies/amendment-diff/${amendmentId}`);
}

function verifyPolicy(policyId) {
  return api().get(`policies/${policyId}/verify`);
}

export {
  createAmendmentFromPolicy,
  findPolicyAmendments,
  findPolicyAmendmentDiff,
  getPolicyFromId,
  updatePolicyRisk,
  verifyPolicy,
};
